module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.ca8aad13.jpeg";